import colors from 'constants/colors';
import styled from 'styled-components';

export const LegendContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 110px;
  padding: 0 0 10px 0;
  box-sizing: border-box;

  @media only screen and (max-width: 1200px) {
    ${({desktop})=>desktop? `display: none;`: null};
  }

  @media only screen and (min-width: 1200px) {
    ${({mobile})=>mobile? `display: none;`: null};
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    height: 160px;
    margin-top: 300px;
    margin-bottom: 60px;
  }

  @media only screen and (min-width: 501px) and (max-width: 767px) {
    margin-top: 160px;
    padding-bottom: 60px;
  }

  @media only screen and (min-width: 401px) and (max-width: 500px) {
    margin-top: 80px;
    padding-bottom: 60px;
  }

  @media only screen and (min-width: 375px) and (max-width: 400px)  {
    margin-top: 70px;
    padding-bottom: 60px;
  }

  @media only screen and (max-width: 374px) {
    margin-top: 65px;
    padding-bottom: 60px;
  }
`;

export const LegendItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-basis: 14%;
  height: 90px;

  .iconContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    margin-bottom: 8px;
    background-color: ${(props) => props.backgroundColor ? props.backgroundColor : 'white'};
  }

  .iconLayout {
    width: 20px;
    height: 20px;
  }

  span {
    width: 100%;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: 0.5px;
    text-align: center;
    color: ${colors.silver};
  }

  @media only screen and (max-width: 1200px) {
    flex-basis: 25%;

    .iconContainer {
      margin-bottom: 5px;  
    }
  }

  @media only screen and (max-width: 767px) {
    
    .iconContainer {
      width: 30px;
      height: 30px;
    }

    .iconLayout {
      width: 15px;
      height: 15px;
    }

    span{
      font-size: 12px;
    }
  }
`;
